var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardMilestone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6H3C2.175 6 1.5 5.325 1.5 4.5V3C1.5 2.175 2.175 1.5 3 1.5H5.25C6.075 1.5 6.75 2.175 6.75 3V4.5C6.75 5.325 6.075 6 5.25 6Z",
    stroke: "#00A272",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6H3C2.175 6 1.5 5.325 1.5 4.5V3C1.5 2.175 2.175 1.5 3 1.5H5.25C6.075 1.5 6.75 2.175 6.75 3V4.5C6.75 5.325 6.075 6 5.25 6Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 5.25H12.9C12.405 5.25 12 4.84499 12 4.34999V3.15001C12 2.65501 12.405 2.25 12.9 2.25H15.6C16.095 2.25 16.5 2.65501 16.5 3.15001V4.34999C16.5 4.84499 16.095 5.25 15.6 5.25Z",
    stroke: "#00A272",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 5.25H12.9C12.405 5.25 12 4.84499 12 4.34999V3.15001C12 2.65501 12.405 2.25 12.9 2.25H15.6C16.095 2.25 16.5 2.65501 16.5 3.15001V4.34999C16.5 4.84499 16.095 5.25 15.6 5.25Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 10.875H12.9C12.405 10.875 12 10.47 12 9.97499V8.77501C12 8.28001 12.405 7.875 12.9 7.875H15.6C16.095 7.875 16.5 8.28001 16.5 8.77501V9.97499C16.5 10.47 16.095 10.875 15.6 10.875Z",
    stroke: "#00A272",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 10.875H12.9C12.405 10.875 12 10.47 12 9.97499V8.77501C12 8.28001 12.405 7.875 12.9 7.875H15.6C16.095 7.875 16.5 8.28001 16.5 8.77501V9.97499C16.5 10.47 16.095 10.875 15.6 10.875Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3.75H12",
    stroke: "#00A272",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3.75H12",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 3.75V13.5C9.375 14.325 10.05 15 10.875 15H12",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 3.75V13.5C9.375 14.325 10.05 15 10.875 15H12",
    stroke: "#00A272",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 3.75V13.5C9.375 14.325 10.05 15 10.875 15H12",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 9.375H12",
    stroke: "#00A272",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 9.375H12",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 16.5H12.9C12.405 16.5 12 16.095 12 15.6V14.4C12 13.905 12.405 13.5 12.9 13.5H15.6C16.095 13.5 16.5 13.905 16.5 14.4V15.6C16.5 16.095 16.095 16.5 15.6 16.5Z",
    stroke: "#00A272",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 16.5H12.9C12.405 16.5 12 16.095 12 15.6V14.4C12 13.905 12.405 13.5 12.9 13.5H15.6C16.095 13.5 16.5 13.905 16.5 14.4V15.6C16.5 16.095 16.095 16.5 15.6 16.5Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMilestone);
export default __webpack_public_path__ + "static/media/dashboard-milestone.8990d28fb8603527b51549d0e0c7ee55.svg";
export { ForwardRef as ReactComponent };